import { ButtonProps } from '@heroui/react'

export enum FrequencyEnum {
  Yearly = 'yearly',
  Monthly = 'monthly',
}

export type Frequency = {
  key: FrequencyEnum
  label: string
  priceSuffix: string
}

export type Product = {
  key: string
  title: string
  price: {
    [FrequencyEnum.Yearly]: {
      id: string
      displayPrice: string
      mostPopular: boolean
    }
    [FrequencyEnum.Monthly]: {
      id: string
      displayPrice: string
      mostPopular: boolean
    }
  }
  priceSuffix?: string
  description?: string
  mostPopular?: boolean
  features?: string[]
  buttonText: string
  buttonColor?: ButtonProps['color']
  buttonVariant: ButtonProps['variant']
}

export const frequencies: Array<Frequency> = [
  { key: FrequencyEnum.Monthly, label: 'Pay Monthly', priceSuffix: 'per month' },
  { key: FrequencyEnum.Yearly, label: 'Pay Yearly', priceSuffix: 'per year' },
]

export type BillingModalCopyItem = {
  title: string
  body: string
  ctaText: string
  hideUpgradeSection?: boolean // if true, hide the upgrade section in the modal
}

export type BillingModalCopy = {
  TRIAL_LIMIT_EXPORT_COUNT: BillingModalCopyItem
  TRIAL_LIMIT_DOCS_COUNT: BillingModalCopyItem
  TRIAL_LIMIT_AI_IMPROVEMENTS: BillingModalCopyItem
  TRIAL_LIMIT_REVIEWS_COUNT: BillingModalCopyItem
  PAID_LIMIT_EXPORT_COUNT: BillingModalCopyItem
  NO_SUBSCRIPTION: BillingModalCopyItem
}

export type ProductMetadata = {
  trialDocsCap?: number
  trialExportCap?: number
  trialAiImprovementCap?: number
  trialReviewsCap?: number
  paidExportCap?: number
  maxSignupsPerIp?: number
  signupRateLimitWindow?: number
  copy?: BillingModalCopy
  [key: string]: any
}

export interface UserSubscriptionMetadata {
  docsCount?: number
  reviewsCount?: number
  paidExportCount?: {
    date: string
    count: number
  }
  [key: string]: unknown
}
